<template>
  <div class="game-form-page-teams">
    <div class="game-form-page-teams__team">
      <!-- Home Team Label -->
      <app-i18n
        code="entities.game.fields.homeTeam"
        class="game-form-page-teams__team__home__label"
      ></app-i18n>
      <!-- Home Team Name -->
      <span
        class="game-form-page-teams__team__home__name"
        v-text="homeTeam.name"
      />
      <!-- Home Team School Name -->
      <span
        class="game-form-page-teams__team__home__school"
        v-text="homeSchoolName"
      />
      <!-- Home Team Image -->
      <img class="game-form-page-teams__team__home__image" :src="homeTeamLogo" />

      <!-- VS -->
      <i class="game-form-page-teams__team__vs icon-games" />

      <!-- Away Team Image -->
      <img class="game-form-page-teams__team__away__image" :src="awayTeamLogo" />
      <!-- Away Team Label -->
      <app-i18n
        code="entities.game.fields.awayTeam"
        class="game-form-page-teams__team__away__label"
      ></app-i18n>
      <!-- Away Team Name -->
      <span
        class="game-form-page-teams__team__away__name"
        v-text="awayTeam.name"
      />
      <!-- Away Team School Name -->
      <span
        class="game-form-page-teams__team__away__school"
        v-text="awaySchoolName"
      />
    </div>

    <!-- <div class="game-form-page-teams__status" v-if="!isDisputedResult && model">
      <i
        :style="getTagStyle('status', model.status ? model.status : 'toPlay')"
        class="icon-radio-button-fill"
      />
      <span v-text="i18n(`enumerators.gameStatus.${model.status ? model.status : 'toPlay'}`)" />
    </div> -->

    <!-- 
      - FORM con función especifica de cambiar el resultado de un partido en disputa:
      -   * Este form solo será visible si el estado del partido está en disputa
      -   * Una vez que se envie este resultado no se podrá volver a modificar
      -   * Al cambiar este resultado se tendrá que enviar un email con el resultado a los coaches y schoolManagers de ese Team
    -->
    <el-form
      :model="model"
      class="game-form-page-teams__results"
      ref="form"
      v-if="model"
    >
      <!-- Home team score  -->
      <el-form-item :label="i18n('entities.game.fields.results')" class="game-form-page-teams__results__homeScore">
        <el-input
          placeholder="Home team score"
          prefix-icon="icon-document"
          v-model="model.homeTeamScore"
        />
      </el-form-item>
      <!-- Status -->
      <div class="game-form-page-teams__results__status" v-if="model">
        <i
          :style="getTagStyle('status', model.status ? model.status : 'toPlay')"
          class="icon-radio-button-fill" 
        />
        <span v-text="i18n(`enumerators.gameStatus.${model.status ? model.status : 'toPlay'}`)" />
      </div>
      <!-- <div class="game-form-page-teams__results__status">
        <i :style="getTagStyle('status', model.status)" class="icon-radio-button-fill" />
        <span v-text="i18n(`enumerators.gameStatus.${model.status}`)" />
      </div> -->
      <!-- Away team score -->
      <el-form-item :label="i18n('entities.game.fields.results')" class="game-form-page-teams__results__awayScore">
        <el-input
          placeholder="Away team score"
          prefix-icon="icon-document"
          v-model="model.awayTeamScore"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { get } from 'lodash';
import { i18n } from '@shared/i18n';
import TagsFactory from '@shared/factories/tags-factory';

export default {
  name: 'app-game-form-page-teams',
  props: {
    homeTeam: {
      type: Object
    },
    awayTeam: {
      type: Object
    },
    awaySchool: {
      type: String
    }, 
    isDisputedResult: {
      type: Boolean
    },
    model: {
      type: Object
    },
  },
  computed: {
    homeTeamLogo() {
      return get(this, 'homeTeam.logo[0].publicUrl', '');
    },

    homeSchoolName() {
      return get(this, 'homeTeam.school.name', i18n('entities.game.list.empty.school'));
    }, 

    awayTeamLogo() {
      return get(this, 'awayTeam.logo[0].publicUrl', '');
    },

    awaySchoolName() {
      return get(this, 'awayTeam.school.name', i18n('entities.game.list.empty.school'));
    }, 
  },
  methods: {
    i18n(code) {
      return i18n(code);
    },
    getTagStyle(keyEnum, valueEnum) {
      const style = new TagsFactory({
        entityName: 'gameStatus',
      }).getTagStyle({
        keyEnum: keyEnum,
        valueEnum: valueEnum,
      });
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>

  .game-form-page-teams {
    // padding: 56px 64px 0 64px;
    &__team {
      display: grid;
      grid-template-areas:
        'homeLabel homeImg vs awayImg awayLabel'
        'homeName homeImg vs awayImg awayName'
        'homeSchool homeImg vs awayImg awaySchool';
      grid-template-columns: 35% 11% 8% 11% 35%;
      align-items: center;

      &__home__label {
        grid-area: homeLabel;
        font-size: 12px;
        color: #c5c5c5;
      }
      &__home__name {
        grid-area: homeName;
        font-size: 20px;
        color: #404040;
        text-transform: uppercase;
      }
      &__home__school {
        grid-area: homeSchool;
        font-size: 12px;
        color: #404040;
      }
      &__home__image {
        grid-area: homeImg;
        width: 80px;
        justify-self: flex-end;
      }
      &__vs {
        grid-area: vs;
        font-size: 40px;
        color: #cccccc;
        justify-self: center;
      }
      &__away__label {
        grid-area: awayLabel;
        font-size: 12px;
        color: #c5c5c5;
        justify-self: flex-end;
      }
      &__away__name {
        grid-area: awayName;
        font-size: 20px;
        text-transform: uppercase;
        color: #404040;
        justify-self: flex-end;
      }
      &__away__school {
        grid-area: awaySchool;
        font-size: 12px;
        color: #404040;
        justify-self: flex-end;
      }
      &__away__image {
        grid-area: awayImg;
        width: 80px;
      }
    }
    &__results {
      padding: 16px 0 0 0 !important;
      display: grid;
      grid-template-areas: 'homeScore status awayScore';
      align-items: center;
      &__homeScore {
        grid-area: homeScore;
        justify-self: flex-start;
      }
      &__status {
        grid-area: status;
        justify-self: center;
        display: grid;
        grid-template-areas: 'icon status';
        justify-content: center;
        align-items: center;
        background-color: #fff;
        width: 140px;
        box-shadow: 0 2px 5px 0 rgba(223, 223, 223, 0.7);
        border-radius: 5px;
        padding: 8px;
        gap: 8px;
        span {
          color: #606266;
        }
      }
      &__awayScore {
        margin-bottom: 22px !important;
        grid-area: awayScore;
        justify-self: flex-end;
      }
    }

    &__status {
      display: grid;
      grid-template-areas: 'icon status';
      justify-content: center;
      align-items: center;
      background-color: #fff;
      width: 140px;
      box-shadow: 0 2px 5px 0 rgba(223, 223, 223, 0.7);
      border-radius: 5px;
      padding: 8px;
      gap: 8px;
      margin: 24px auto 0px auto;
      span {
        color: #606266;
      }
    }
  }

</style>